exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".members-bp-memberpress-upgrade {\n\tbackground-color: #f5f5f5;\n\tpadding: 20px;\n\tmargin-bottom: 20px;\n}\n\n.members-bp-memberpress-upgrade__cta-button {\n\tbackground-color: #06429e;\n\tcolor: #fff;\n\ttext-decoration: none;\n\tborder-radius: 300px;\n\tmargin: 20px auto 0;\n\twidth: auto;\n\ttext-align: center;\n\tmax-width: 200px;\n\tpadding: 10px;\n\tdisplay: block;\n\theight: auto;\n}\n\n.members-bp-memberpress-upgrade__cta-button:hover {\n\tcolor: #fff;\n}", ""]);

// exports
